import React from 'react';
import AcronIQLoginForm from '../components/AcronIQLoginForm';
import styled from 'styled-components';

const LoginDemo = () => {
  return (
    <DemoWrapper>
      <div className="demo-container">
        <div className="demo-header">
          <h1>AcronIQ Veritus Login Design</h1>
          <p>Beautiful login form with AcronIQ blue branding</p>
        </div>
        <div className="form-showcase">
          <AcronIQLoginForm />
        </div>
        <div className="demo-info">
          <h3>🎨 Design Features:</h3>
          <ul>
            <li>✅ AcronIQ Blue Brand Colors (#1E40AF, #3B82F6, #2563EB)</li>
            <li>✅ Gradient backgrounds and hover effects</li>
            <li>✅ Modern glassmorphism styling</li>
            <li>✅ Smooth animations and transitions</li>
            <li>✅ Responsive design for all devices</li>
            <li>✅ Professional AcronIQ Veritus branding</li>
          </ul>
        </div>
      </div>
    </DemoWrapper>
  );
};

const DemoWrapper = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #0F172A 0%, #1E293B 50%, #334155 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;

  .demo-container {
    max-width: 1200px;
    width: 100%;
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    gap: 40px;
    align-items: center;
  }

  .demo-header {
    text-align: center;
    color: white;
  }

  .demo-header h1 {
    font-size: 2.5rem;
    font-weight: 900;
    margin-bottom: 10px;
    background: linear-gradient(135deg, #3B82F6 0%, #60A5FA 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  .demo-header p {
    font-size: 1.1rem;
    color: #94A3B8;
    margin: 0;
  }

  .form-showcase {
    display: flex;
    justify-content: center;
  }

  .demo-info {
    background: rgba(255, 255, 255, 0.05);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 20px;
    padding: 30px;
    color: white;
  }

  .demo-info h3 {
    color: #60A5FA;
    margin-bottom: 20px;
    font-size: 1.3rem;
  }

  .demo-info ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .demo-info li {
    padding: 8px 0;
    font-size: 0.95rem;
    color: #E2E8F0;
  }

  @media (max-width: 1024px) {
    .demo-container {
      grid-template-columns: 1fr;
      text-align: center;
      gap: 30px;
    }
  }

  @media (max-width: 768px) {
    .demo-header h1 {
      font-size: 2rem;
    }
    
    .demo-info {
      padding: 20px;
    }
  }
`;

export default LoginDemo;
